'use client';

import React, { ComponentType, memo, forwardRef } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface IProps {
  id?: string;
  /** 동적 HTML 요소 */
  as?: string | ComponentType<any> | undefined;
  className?: string;
  /** children */
  children?: React.ReactNode;
  /** padding-left */
  pl?: string | number;
  /** padding-right */
  pr?: string | number;
  /** padding-top */
  pt?: string | number;
  /** padding-bottom */
  pb?: string | number;
  /** align */
  align?: string;
  /** border-top */
  bdt?: string;
  /** border-bottom */
  bdb?: string;
  /** margin-left */
  ml?: string | number;
  /** margin-right */
  mr?: string | number;
  /** margin-top */
  mt?: string | number;
  /** margin-bottom */
  mb?: string | number;
  /** background color */
  bgColor?: string;
  /** row-gap */
  rowGap?: number;
  /** column-gap */
  colGap?: number;
  /** style */
  style?: React.CSSProperties;
}

const Box = forwardRef<HTMLElement, IProps>(
  (
    {
      id,
      as,
      className,
      children,
      pl,
      pr,
      pt,
      pb,
      align,
      bdt,
      bdb,
      ml,
      mr,
      mt,
      mb,
      bgColor,
      rowGap,
      colGap,
    },
    ref
  ) => {
    const param = {
      id,
      as,
      className: classNameBind(['box', className || '']),
      $pl: pl,
      $pr: pr,
      $pt: pt,
      $pb: pb,
      $align: align,
      bdt,
      bdb,
      $ml: ml,
      $mr: mr,
      $mt: mt,
      $mb: mb,
      $bgColor: bgColor,
      $rowGap: rowGap,
      $colGap: colGap,
    };
    return (
      <S.Box ref={ref} {...param}>
        {children}
      </S.Box>
    );
  }
);

Box.displayName = 'Box';

export default memo(Box);
